import loadable from '@loadable/component'

import Highlight from './Highlight'
import Highlights from './Highlights'
import HighlightText from './HighlightText'

export const HighlightChart = loadable(() => import('./HighlightChart'))
export const HighlightImage = loadable(() => import('./HighlightImage'))
export const HighlightVideo = loadable(() => import('./HighlightVideo'))

export { Highlight }
export { Highlights }
export { HighlightText }
export type { HighlightProps } from './Highlight'
export type { HighlightChartProps } from './HighlightChart'
export type { HighlightImageProps } from './HighlightImage'
export type { HighlightTextProps } from './HighlightText'
export type { HighlightVideoProps } from './HighlightVideo'
